export default "__VITE_ASSET__dB4ctL8q__"